// extracted by mini-css-extract-plugin
module.exports = {"search":"style_search__cZrFe","search-bar-wrapper":"style_search-bar-wrapper__vg4c9"};